<div class="header-bar">
  <div class="c-hamburger-spacer">
  </div>
  <div class="c-logo">
    <!-- logo  -->
    <div class="header-logo">
      <a [routerLink]="['/']">
        <!-- Unified LEAP brand (35749): one neutral SEG logo for every brand -->
        <img src="../../../assets/img/seg-logo_light.png" alt="logo" class="logo-header-light" />
      </a>
    </div>
    <!-- logo: end -->
  </div>

  <div class="c-quicklinks">
    <ul class="quicklinks">
      <!-- <li class="quicklink quicklink--help">
      <div class="quicklink--icon">   --- Left in for demonstration   ---   </div>
    </li>
    <li class="quicklink quicklink--notification">
      <div class="quicklink--icon">
        <svg id="Merged" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
          <path
            id="ico-bell"
            class="cls-3"
            d="M313.223,430.872a60.067,60.067,0,1,1-112.824,0H60.854V391.484c37.419,0,37.419-39.388,37.419-39.388V199.66c0-99.831,64.588-143.36,120.533-156.3a36.437,36.437,0,1,1,72.115-.35c56.377,12.6,122.458,56.5,122.458,156.654V352.1c0,40.286,37.419,39.388,37.419,39.388v39.388H313.223ZM373.991,352.1V199.66c0-119.192-118.165-122.252-118.165-122.252s-118.165,0-118.165,122.253V352.1s0,39.388-19.694,39.388H395.654C373.991,391.484,373.991,352.1,373.991,352.1Z"
            />
          </svg>
        </div>
      </li> -->
    </ul>
  </div>
